import React from 'react';
import styled from "styled-components";
import PropTypes from "prop-types";

const StyledSvg = styled.svg`
  margin-top: ${(props) => props.marginTop};
  float: left;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-width: 100px;
  min-width: 100px;
`;

const RightArrow = ({color, marginTop, viewBox, width, height}) => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" width={width} height={height} marginTop={marginTop || '3px'} viewBox={viewBox || '0 0 25 25'}>
    <path fillRule="evenodd" fill={color || "#FFFFFF"}
      d="M1.19139 8.76109e-05L0 1.23891L3.61714 5.00004L0 8.76118L1.19139 10L5.99992 5.00004L1.19139 8.76109e-05Z"/>
  </StyledSvg>
);

RightArrow.propTypes = {
  color: PropTypes.string,
  marginTop: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

export default RightArrow;
